import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const iconBgColors = [
  'bg-primary-100',
  'bg-accent-100',
  'bg-secondary-100',
  'bg-primary-100',
  'bg-accent-100',
  'bg-secondary-100',
];

const iconTextColors = [
  'text-primary-600',
  'text-accent-700',
  'text-secondary-700',
  'text-primary-600',
  'text-accent-700',
  'text-secondary-700',
];

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold tracking-wide mb-4">
            产品分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            探索 aiye 产品矩阵
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base leading-relaxed">
            六大核心产品线，覆盖企业数字化的每一个关键节点
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat, idx) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-6 md:p-7 rounded-2xl bg-background-100 border border-background-200/70 transition-all duration-300 hover:border-primary-200 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className={`w-12 h-12 rounded-xl ${iconBgColors[idx % 6]} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl ${iconTextColors[idx % 6]}`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">{cat.count} 个产品</span>
                <span className="text-primary-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center gap-1">
                  查看详情 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}